import * as React from "react";
import { Button, HStack, Text } from "@chakra-ui/react";
import { ActionButtonProps } from "./types";
import { InfoOutlineIcon } from "@chakra-ui/icons";

export const ActionButton: React.FC<ActionButtonProps> = ({ text, onClick }) => (
  <Button variant="outline" size="xs" onClick={onClick} borderRadius="full" color="gray.600">
    <HStack spacing={2}>
      <InfoOutlineIcon />
      <Text>{text}</Text>
    </HStack>
  </Button>
);
